import { useState } from 'react';
import { ICreateQuote } from '../../../../constants/interfaces';

import { createQuoteApi } from './../../../../apis/index';

import { validateDataToSend } from './functions';

import {
  Wrapper,
  TopHeading,
  FormWrapper,
  Row,
  InputWrapper,
  Success,
  // RadioWrapper,
  // SingleRadioOption,
  TextArea,
  Error,
  ButtonWrapper,
  SubmitButton,
} from './Styles';

const QuoteForm = () => {
  const [error, setError] = useState<string>('');
  const [isQuoteCreating, setIsQuoteCreating] = useState<boolean>(false);
  const [isQuoteCreatedSuccessfully, setIsQuoteCreatedSuccessfully] =
    useState<boolean>(false);

  const [dataToSend, setDataToSend] = useState<ICreateQuote>({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    companyName: '',
    interested: '',
  });

  const changeHandler = (e: any) => {
    setIsQuoteCreatedSuccessfully(false)
    setError('');
    setDataToSend((prevState: any) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleClearAllInputFields = () => {
    setDataToSend({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      companyName: '',
      interested: '',
    });
  };

  const handleSubmit = async () => {
    if (validateDataToSend(dataToSend, setError)) {
      try {
        setIsQuoteCreating(true);
        const res = await createQuoteApi(dataToSend);
        console.log(res);
        setIsQuoteCreatedSuccessfully(true);
        setIsQuoteCreating(false);
        handleClearAllInputFields();
      } catch (error: any) {
        setIsQuoteCreating(false);
        console.log(error);
      }
    }
  };

  return (
    <Wrapper>
      <TopHeading>Request A Quote</TopHeading>
      <FormWrapper>
        <h3 className="formHeading">Personal Information:</h3>
        <Row>
          <InputWrapper>
            <input
              type="text"
              placeholder="First Name*"
              name="firstName"
              value={dataToSend?.firstName}
              onChange={changeHandler}
            />
          </InputWrapper>
          <InputWrapper>
            <input
              type="text"
              placeholder="Last Name*"
              name="lastName"
              value={dataToSend?.lastName}
              onChange={changeHandler}
            />
          </InputWrapper>
        </Row>
        <Row>
          <InputWrapper>
            <input
              type="text"
              placeholder="Email *"
              name="email"
              value={dataToSend?.email}
              onChange={changeHandler}
            />
          </InputWrapper>
          <InputWrapper>
            <input
              type="text"
              placeholder="Phone Number*"
              name="phone"
              value={dataToSend?.phone}
              onChange={changeHandler}
            />
          </InputWrapper>
        </Row>
        <Row>
          <InputWrapper>
            <input
              type="text"
              placeholder="Company Name"
              name="companyName"
              value={dataToSend?.companyName}
              onChange={changeHandler}
            />
          </InputWrapper>
        </Row>
        {/* <RadioWrapper>
          <SingleRadioOption onClick={() => setRadioValue('Shipping')}>
            <div
              className={`radio ${radioValue === 'Shipping' ? 'selected' : ''}`}
            >
              <div className="circle"></div>
            </div>
            <span className="label">Shipping</span>
          </SingleRadioOption>
          <SingleRadioOption onClick={() => setRadioValue('Fulfillment')}>
            <div
              className={`radio ${
                radioValue === 'Fulfillment' ? 'selected' : ''
              }`}
            >
              <div className="circle"></div>
            </div>
            <span className="label">Fulfillment</span>
          </SingleRadioOption>
          <SingleRadioOption onClick={() => setRadioValue('FBA Prep')}>
            <div
              className={`radio ${radioValue === 'FBA Prep' ? 'selected' : ''}`}
            >
              <div className="circle"></div>
            </div>
            <span className="label">FBA Prep</span>
          </SingleRadioOption>
          <SingleRadioOption onClick={() => setRadioValue('Other')}>
            <div
              className={`radio ${radioValue === 'Other' ? 'selected' : ''}`}
            >
              <div className="circle"></div>
            </div>
            <span className="label">Other</span>
          </SingleRadioOption>
        </RadioWrapper> */}
        <TextArea
          placeholder="Why Are You Interested?"
          name="interested"
          value={dataToSend?.interested}
          onChange={changeHandler}
        />
        {!!error && <Error>{error}</Error>}
        {isQuoteCreatedSuccessfully && (
          <Success>
            Quote Created Successfully. We will contact to you soon.
          </Success>
        )}
        <ButtonWrapper>
          <SubmitButton onClick={handleSubmit}>
            <span className="text">
              {isQuoteCreating ? 'Processing' : 'Submit'}
            </span>
          </SubmitButton>
        </ButtonWrapper>
      </FormWrapper>
    </Wrapper>
  );
};

export default QuoteForm;
